import { render, staticRenderFns } from "./department-right.vue?vue&type=template&id=41872ffc&scoped=true"
import script from "./department-right.vue?vue&type=script&lang=js"
export * from "./department-right.vue?vue&type=script&lang=js"
import style0 from "./department-right.vue?vue&type=style&index=0&id=41872ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41872ffc",
  null
  
)

export default component.exports